import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.mapatacloud.com';

class CategoriesService {
  
  /**
   * Récupérer les statuts des catégories de services
   * UNIQUEMENT depuis l'API - pas de fallback local
   * @returns {Promise<Object>} - Statuts des catégories
   * @throws {Error} - Lance une erreur si l'API est inaccessible
   */
  async getCategoriesStatus() {
    try {
      const response = await axios.get(`${API_BASE}/config/categories`, {
        headers: {
          'accept': 'application/json'
        },
        timeout: 10000 // Timeout de 10 secondes
      });

      if (response.data && response.data.code === 0) {
        return response.data.result;
      }

      throw new Error(response.data?.msg || 'Erreur lors de la récupération des catégories');
    } catch (error) {
      console.error('❌ Erreur getCategoriesStatus:', error.message);
      // Propager l'erreur sans fallback - Redux gérera l'état d'erreur
      throw error;
    }
  }

  /**
   * Rafraîchir périodiquement les statuts des catégories
   * @param {Function} callback - Fonction à appeler avec les nouveaux statuts
   * @param {number} interval - Intervalle en millisecondes (défaut: 5 minutes)
   * @returns {number} - ID de l'intervalle pour pouvoir l'arrêter
   */
  startAutoRefresh(callback, interval = 300000) {
    return setInterval(async () => {
      try {
        const status = await this.getCategoriesStatus();
        callback(status);
      } catch (error) {
        console.error('Erreur lors du rafraîchissement des catégories:', error);
      }
    }, interval);
  }

  /**
   * Arrêter le rafraîchissement automatique
   * @param {number} intervalId - ID de l'intervalle retourné par startAutoRefresh
   */
  stopAutoRefresh(intervalId) {
    clearInterval(intervalId);
  }
}

const categoriesService = new CategoriesService();
export default categoriesService;
